import { render, staticRenderFns } from "./confirmSheba.vue?vue&type=template&id=86020114"
import script from "./confirmSheba.vue?vue&type=script&lang=js"
export * from "./confirmSheba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports